import React, { useState, useEffect } from 'react';
import ScoreIcon from "assets/images/images_new/pie-chart-icon.svg";
import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
import Content from "/public/images/popup-icons/Content.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";
import BarFrequency from "/public/images/popup-icons/popupBar.png";
import Grammar from "/public/images/popup-icons/Grammar.png";
import Vocabulary from "/public/images/popup-icons/Vocabulary.png";
import FormIcon from "/public/images/popup-icons/Form.png";

export default function SpeakingResult(props) {
	const [result, setResult] = useState(null);
	const NOT_ALLOWED = ['overall'];

	const ICON_MAP = {
		content: Content,
		fluency: Fluency,
		pronunciation: Pronunciation,
		overall: BarFrequency,
		grammar: Grammar,
		form: FormIcon,
		vocabulary: Vocabulary,
	};

	const getIconByType = (type) => {
		return ICON_MAP[type?.toLowerCase()] || "";
	};

	useEffect(() => {
		const { resultData } = props;
		setResult(resultData);
	}, []);

	const scoreClass = (score) => {
		let class_name = "color-danger";

		if (score > 30 && score <= 60) {
			class_name = "color-warning";
		} else if (score > 60) {
			class_name = "color-success";
		}

		return class_name;
	}
	const score = props.subcategoryId !== 5 
	? result?.overall?.score 
	: result?.content?.score;

	const outOf = props.subcategoryId !== 5 
	? result?.overall?.out_of 
	: result?.content?.out_of;

	const percent = outOf ? (score / outOf) * 100 : 0;

	return (
		<>
			{/* {result !== null &&
				<>
					<div className='result-score-row d-flex flex-column gap-3 gap-xl-0 d-xl-grid '>
						<div className='score-content'>
							<div className='score-circle-content'>
								<div className='score-circle'></div>
								<div className='score-circle-text'>
									<p>Overall Score</p>
									{props.subcategoryId !== 5 ? (
										<h2>{result?.overall?.score}/{result?.overall?.out_of}</h2>
									) : (
										<h2>{result?.content?.score}/{result?.content?.out_of}</h2>
									)}
								</div>
							</div>
							<ul className="score-list">
								{Object.keys(result).map((item, i) => {
									if (!NOT_ALLOWED.includes(item)) {
										return (
											<li key={i}>
												{result[item]?.label}: <span><img src={ScoreIcon} alt="LA" /> {result[item]?.score}/{result[item]?.out_of}</span>
											</li>
										)
									}
								})}
							</ul>
						</div>

						<div className='result-submitted-record m-0 w-lg-auto'>
							<h2>Submitted Record</h2>
							<audio controls>
								<source src={props.recorded_file} />
								Your browser does not support the audio element.
							</audio>
						</div>
					</div>

					<div className='gab-card result-content'>
						 {
							props?.subcategoryId !== 5 && (
								<ul className="result-markers result-category d-block d-lg-flex">
							<li>
								<span className="good"></span> Good
							</li>
							<li>
								<span className="average"></span>Average
							</li>
							<li>
								<span className="bad"></span>Bad Pronunciation/Missed words
							</li>
						</ul>
							)
						 }

						<div className='gab-text'>
							{props?.newHtml !== null && props?.newHtml !== "[]" &&
								<>
									{props.renderResponseHtml(props.newHtml)}
									{props.subcategoryId === 5 &&
										<p>Correct Answer - <span className="color-success">{props.correctAnswer}</span></p>
									}
								</>
							}

							{Array.isArray(props?.newHtml) && props?.newHtml.length === 0 && props?.html &&
								<div dangerouslySetInnerHTML={{ __html: props.html }} />
							}

							{props?.newHtml !== "[]" && props.newResult !== null && props.newResult !== undefined && 'html' in props.newResult &&
								props.renderResponseHtmlOldStyle(props.newResult.html)
							}
						</div>

						<div className='result-view-remarks'>
							{props.moreDetails}
						</div>
					</div>
				</>
			} */}
			{(result !== null && props.showMainContent) && (
				<>
					{/* TOP SECTION */}
					<div className="card popup-border p-4 mb-4">

						<div className="row align-items-center">

						{/* LEFT */}
						<div className="col-12 col-lg-6 text-center text-lg-start mb-4 mb-lg-0">

							<div className="d-flex flex-column flex-sm-row align-items-center gap-3 gap-sm-4 mb-3">
							<div className="score-circle-modern" style={{ "--progress": `${percent}%` }}>
								{/* {props.subcategoryId !== 5
								? `${result?.overall?.score}/${result?.overall?.out_of}`
								: `${result?.content?.score}/${result?.content?.out_of}`} */}
								<span>{score}/{outOf}</span>
							</div>

							<h6 className="result-score mb-0">Overall Score</h6>
							</div>

							<h6 className="status-text mb-2">Submitted Record</h6>

							<RecordedWaveform
							blobURL={props.recorded_file}
							testMode={true}
							feedBack={true}
							/>
						</div>

						{/* RIGHT */}
						<div className="col-12 col-lg-6">
							<div className="d-flex flex-column gap-3">

							{Object.keys(result).map((item, i) => {
								if (!NOT_ALLOWED.includes(item)) {
								return (
									<div
									key={i}
									className="d-flex flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2"
									>
									<div className="d-flex align-items-center gap-2">
										<img
										src={getIconByType(item)}
										alt={result[item]?.label}
										className="img-fluid"
										style={{ width: "30px" }}
										/>
										<span className="label-text">
										{result[item]?.label}
										</span>
									</div>

									<strong className="label-score">
										{result[item]?.score}/{result[item]?.out_of}
									</strong>
									</div>
								);
								}
								return null;
							})}

							</div>
						</div>

						</div>

					</div>

					{/* BOTTOM SECTION */}
					<div className="card popup-border p-4 mb-0">

					{/* Legend */}
					{props?.subcategoryId !== 5 && (
						<ul className="result-markers d-flex flex-wrap gap-3 mb-3 list-unstyled">
						<li><span className="dot good"></span> Good</li>
						<li><span className="dot average"></span> Average</li>
						<li><span className="dot bad"></span> Bad pronunciation/Missed words</li>
						</ul>
					)}
					{props.subcategoryId === 1 && (
					<ul className="result-markers d-flex flex-wrap gap-3 mb-3 list-unstyled">
								<li>
									<div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
										<div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJshort"></div>
										Short pause
									</div>
								</li>
								<li>
									<div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
										<div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJlong"></div>
										Long pause
									</div>
								</li>
							</ul>
						 )}

					{/* Text Content */}
					<div className="mb-4">

						{props?.newHtml !== null && props?.newHtml !== "[]" && (
						<>
							{props.renderResponseHtml(props.newHtml)}

							{props.subcategoryId === 5 && (
							<p>
								Correct Answer -{" "}
								<span className="text-success fw-semibold">
								{props.correctAnswer}
								</span>
							</p>
							)}
						</>
						)}

						{Array.isArray(props?.newHtml) &&
						props?.newHtml.length === 0 &&
						props?.html && (
							<div dangerouslySetInnerHTML={{ __html: props.html }} />
						)}

						{props?.newHtml !== "[]" &&
						props.newResult &&
						"html" in props.newResult &&
						props.renderResponseHtmlOldStyle(props.newResult.html)}
					</div>
                  
					</div>
                        {/* {props.speed_percentage !== null && props.speed_percentage !== undefined && (
							<span>Speed: <span className={props.speed_percentage === "Too Slow" ? "color-danger" : (props.speed_percentage === "Too Fast" ? "color-warning" : "color-success")}>{props.speed_percentage}</span>
							</span>
						)} */}
				</>
			)}
			{/* CTA */}
			<div className="text-start">
				<div className="result-view-remarks">
				{props.moreDetails}
				</div>
			</div>

		</>	
	);

	// return (
	// 	<>
	// 		{result !== null &&
	// 			<div className="pmw-outer-wrapper">
	// 				<ul className="result-list">
	// 					{Object.keys(result).map((item, i) => {
	// 						return (
	// 							<li key={i}>
	// 								<h4 className="result-output">
	// 									{/*<span className={result[item].score === 0 ? 'text-danger' : (result[item].score > 0 && result[item].score < result[item].out_of ? 'text-orange' : 'text-success')}>{result[item].score}/{result[item].out_of}</span>*/}
	// 									<span className={scoreClass(result[item].score)}>{result[item].score}/{result[item].out_of}</span>
	// 								</h4>
	// 								<h3>{result[item].label}</h3>
	// 							</li>
	// 						)
	// 					})}
	// 				</ul>
	// 			</div>
	// 		}
	// 	</>	
	// );

}